// @ts-nocheck
import { Column } from 'react-table';
import { ResellerInfoCell } from './ResellerInfoCell';
import { ResellerLastLoginCell } from './ResellerLastLoginCell';
import { ResellerTwoStepsCell } from './ResellerTwoStepsCell';
import { ResellerActionsCell } from './ResellerActionsCell';
import { ResellerSelectionCell } from './ResellerSelectionCell';
import { ResellerCustomHeader } from './ResellerCustomHeader';
import { ResellerSelectionHeader } from './ResellerSelectionHeader';
import { Reseller } from '../../core/_models';
import { FormattedMessage } from 'react-intl';
import { ParentResellerInfoCell } from './ParentResellerInfoCell';

const resellersColumns: ReadonlyArray<Column<Reseller>> = [
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="TABLE.GENERAL.ACTION" />}
        className="text-center min-w-90px"
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => (
      <ResellerActionsCell id={props.data[props.row.index].id} status={props.data[props.row.index].status} />
    ),
  },
  {
    Header: (props) => <ResellerSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <ResellerSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.RESELLERNAME" />}
        className=" text-center min-w-100px"
      />
    ),
    id: 'reseller_name',
    Cell: ({ ...props }) => <ResellerInfoCell reseller={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.PHONE" />}
        className="text-center min-w-90px"
      />
    ),
    accessor: 'phone',
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.CREDITBALANCE" defaultMessage={'Available Balance'} />}
        className="text-center min-w-75px"
      />
    ),
    accessor: 'balance',
    Cell: ({ value }) => <span style={{ color: 'green' }}>{value}</span>,
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.AVAILABLEPAYMENT" defaultMessage={'Available Payment'} />}
        className="text-center min-w-75px"
      />
    ),
    id: 'available_payment',
    Cell: ({ row }) => {
      const total_payments_received = row.original.total_payments_received;
      const total_balance_sent = row.original.total_balance_sent;
      const availablePaymentAmount = total_payments_received - total_balance_sent;
      return (
        <span style={{ color: 'var(--primary-color)' }}>
          {availablePaymentAmount > 0 ? availablePaymentAmount : 0}
        </span>
      );
    },
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.PAYMENT" defaultMessage={'Total Payment'} />}
        className=" text-center min-w-75px"
      />
    ),
    accessor: 'total_payments_received',
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.TOTALBALANCE" defaultMessage={'مجموعه بلانس'} />}
        className="text-center min-w-80px"
      />
    ),
    accessor: 'total_balance_sent',
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.LOANAMOUNT" defaultMessage={'Loan Amount'} />}
        className="text-center min-w-80px"
      />
    ),
    id: 'loan_amount',
    Cell: ({ row }) => {
      const total_payments_received = row.original.total_payments_received;
      const total_balance_sent = row.original.total_balance_sent;
      const loanAmount = total_balance_sent - total_payments_received;
      return <span style={{ color: 'red' }}>{loanAmount > 0 ? loanAmount : 0}</span>;
    },
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.CURRENCYPREFERENCE" />}
        className="text-center min-w-80px"
      />
    ),
    accessor: 'code',
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.PARENTRESELLER" />}
        className="text-center min-w-90px"
      />
    ),
    id: 'parent_reseller_name',
    Cell: ({ ...props }) => <ParentResellerInfoCell reseller={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLER.TABLE.COLUMN.COUNTRY" />}
        className="text-center min-w-70px"
      />
    ),
    accessor: 'country',
  },
  {
    Header: (props) => (
      <ResellerCustomHeader
        tableProps={props}
        title={<FormattedMessage id="ORDER.TABLE.COLUMN.STATUS" />}
        className="text-center min-w-70px"
      />
    ),
    accessor: 'status',
    Cell: ({ value }) => {
      const renderStatusBadge = () => {
        if (value == 1) {
          return <span className="d-block min-w-70px text-center badge badge-success">Active</span>;
        } else if (value == 0) {
          return <span className="d-block min-w-70px text-center badge badge-danger">De-Active</span>;
        }
        return null;
      };
      return renderStatusBadge();
    },
  },

];

export { resellersColumns };
